import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { refreshAccessToken, revokeAccessToken } from 'sideEffects/actions/auth.actions';
import GraphQLProvider from 'sideEffects/api/GraphQLProvider';

import { Loader } from '../../components/Loader';
import { DAY_IN_MILLIS } from '../../utils/dateTime.utils';

const AuthSetup: FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem('code')) {
      setLoading(true);
      const { REACT_APP_COGNITO_URL, REACT_APP_COGNITO_CLIENT_ID, REACT_APP_COGNITO_REDIRECT_URI } = process.env;

      sessionStorage.setItem('redirectURI', window.location.pathname + window.location.search);
      window.location.replace(
        `${REACT_APP_COGNITO_URL}/oauth2/authorize?response_type=code&client_id=${REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${REACT_APP_COGNITO_REDIRECT_URI}`
      );
    } else {
      setTimeout(() => {
        dispatch(revokeAccessToken());
      }, DAY_IN_MILLIS);
    }
  });

  useEffect(() => {
    const refreshToken = sessionStorage.getItem('refreshToken');
    if (refreshToken) {
      dispatch(refreshAccessToken(refreshToken));
    }
  }, []);

  return (
    <>
      {loading ? (
        <Loader text="Authenticating..." />
      ) : (
        <GraphQLProvider>
          <Outlet />
        </GraphQLProvider>
      )}
    </>
  );
};

export default AuthSetup;
